import { render, staticRenderFns } from "./serviciosDetalles.vue?vue&type=template&id=f9d356ac&scoped=true&"
import script from "./serviciosDetalles.vue?vue&type=script&lang=js&"
export * from "./serviciosDetalles.vue?vue&type=script&lang=js&"
import style0 from "./serviciosDetalles.vue?vue&type=style&index=0&id=f9d356ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d356ac",
  null
  
)

export default component.exports